module.exports = __webpack_public_path__ + "img/Clean-Influence-text and slogan (dark).37c06962.png";